import { IForgotPasswordInterface } from "../features/auth/pages/forgotpassword/interfaces/forgot-password.interface";
import { IResetPasswordInterface } from "../features/auth/pages/forgotpassword/interfaces/reset-password.interface";
import { IResponseInterface } from "../interfaces/api-response.interface";
import { ILogInInterface } from "../features/auth/pages/login/interface/login.interface";
import { IProfileSetupInterface } from "../features/auth/pages/signup/interfaces/profile-setup.interface";
import { ISignUpInterface } from "../features/auth/pages/signup/interfaces/sign-up.interface";
import { HttpService } from "./base.service";
import { IToken } from "../features/auth/pages/login/interface/token.interface";
import { IUser } from "../features/auth/pages/login/interface/user.interface";
import { IOrganization } from "../features/organisations/createorganisation/interfaces/organisation.interface";
import { IOrganizationSubscription } from "../features/organisations/createorganisation/interfaces/organisation-subscription.interface";
class AdminService extends HttpService {
  

  getOrganizations = (data: {page: number, limit: number}): Promise<IResponseInterface<{organizations:IOrganization}>> => this.get(`organization/all`, data);

  subscription = (data: any): Promise<IResponseInterface<{subscription:IOrganizationSubscription}>> => this.post(`organization-subscription`, data);

  /**
   * Its own admin-guarded endpoint rather than a field on the subscription
   * form: that endpoint has no role check, so routing a security setting
   * through it would let any authenticated user disable 2FA for any org.
   */
  toggleTwoFactor = (
    organizationId: string,
    isTwoFactorEnabled: boolean,
    twoFactorRoleIds?: string[],
  ): Promise<IResponseInterface<{
    organization: IOrganization;
    twoFactorRoleIds: string[];
    /** Scoped to the selected roles, so it reports who is actually affected. */
    coverage: { total: number; withoutVerifiedPhone: number };
  }>> => this.put(`organization/${organizationId}/two-factor`, {
    isTwoFactorEnabled,
    // Omitted rather than sent empty: the API reads a missing list as "every
    // role" and refuses an explicitly empty one.
    ...(twoFactorRoleIds ? { twoFactorRoleIds } : {}),
  });
}
export const adminService = new AdminService();
